/**
* 基础菜单 店铺分类管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>店铺分类管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.sort_name" placeholder="输入分类名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.sort_id" placeholder="输入排序号" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="formInline.status" placeholder="请选择状态" clearable>
          <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="primary" @click="addSortdialog" class="add-button">新增</el-button>
        <el-button size="small" type="primary" @click="editSortdialog" class="edit-button">修改</el-button>
        <el-button size="small" type="danger" @click="delSort">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 510px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 60%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="sort_name" label="分类名称" min-width="160" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="sort_id" label="排序号" width="100" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="product_num" label="商品数量" width="120" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status?true:false"
              active-color="#409EFF">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间" width="150">
        </el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="success" size="mini"
                       @click="addProduct(scope.row.id)">
              添加商品
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="sortDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form label-width="120px" :model="sortForm" :rules="sortRules" ref="sortForm" class="sortForm">
        <el-form-item label="分类名称" prop="sort_name">
          <el-input size="small" v-model="sortForm.sort_name" auto-complete="off" clearable
                    placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="sort_id">
          <el-input size="small" v-model="sortForm.sort_id" auto-complete="off" clearable
                    placeholder="请输入排序号"></el-input>
        </el-form-item>
        <el-form-item label="有效状态" prop="status">
          <el-select v-model="sortForm.status" placeholder="请选择有效状态" clearable>
            <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">关 闭</el-button>
            <el-button type="primary" @click="saveSort('sortForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="添加商品" :before-close="prodHandleClose"
               :visible.sync="addProductDialogVisible"
               width="82%"
               center>
      <div class="flexCenter">
        <div class="inline_block">
          <h3 style="float: left">待选列表</h3>
          <div style="float: right;margin-top: 1em">
            <el-input size="small" v-model="selectContent" placeholder="请输入销售名称/商品编码" clearable style="width: 250px;"></el-input>
            <el-button size="small" type="primary" @click="searchSelect">查询</el-button>
          </div>
          <el-table size="small"
                    :data="selectAddProductTableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)"
                    highlight-current-row v-loading="loading" border
                    @cell-dblclick="cellDbClick" @selection-change="selectDataChange" ref="multipleselectTable"
                    :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                    element-loading-text="拼命加载中" style="width: 100%;height: 452px;overflow: auto">
            <el-table-column align="center" type="selection" width="60">
            </el-table-column>
            <el-table-column
              label="序号"
              width="50">
              <template slot-scope="scope">
                {{pageSize * (currentPage - 1) + (scope.$index + 1)}}
              </template>
            </el-table-column>
            <el-table-column prop="sale_name" label="销售名称" min-width="220" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="product_code" label="商品编码" width="180" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="sale_price" label="销售单价" width="100" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <div>￥{{scope.row.sale_price}}</div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页组件 -->
          <div class="block" style="margin-top: 15px">
            <el-pagination
              background
              @size-change="handleLeftSizeChange"
              @current-change="handleLeftCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="selectAddProductTableData.length"
            >
            </el-pagination>
          </div>
        </div>
        <div class="inline_block" style="margin: 0 20px">
          <div class="mb20">
            <el-button type="primary" icon="el-icon-arrow-left" @click="gotoLeft"
            ></el-button>
          </div>
          <div>
            <el-button type="primary" icon="el-icon-arrow-right" @click="gotoRight"
            ></el-button>
          </div>
        </div>
        <div class="inline_block">
          <h3>已选列表</h3>
          <el-table size="small"
                    :data="selectedAddProductTableData.slice((currentPageRight - 1) * pageSizeRight, currentPageRight * pageSizeRight)"
                    highlight-current-row v-loading="loading" border
                    @cell-dblclick="cellDbClick" @selection-change="selectedDataChange" ref="multipleselectedTable"
                    :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                    element-loading-text="拼命加载中" style="width: 100%;height: 452px;overflow: auto">
            <el-table-column align="center" type="selection" width="60">
            </el-table-column>
            <el-table-column
              label="序号"
              width="50">
              <template slot-scope="scope">
                {{pageSizeRight * (currentPageRight - 1) + (scope.$index + 1)}}
              </template>
            </el-table-column>
            <el-table-column prop="sale_name" label="销售名称" min-width="240" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="product_code" label="商品编码" width="200" :show-overflow-tooltip='true'>
            </el-table-column>
            <el-table-column prop="sale_price" label="销售单价" width="100" :show-overflow-tooltip='true'>
              <template slot-scope="scope">
                <div>￥{{scope.row.sale_price}}</div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页组件 -->
          <div class="block" style="margin-top: 15px">
            <el-pagination
              background
              @size-change="handleRightSizeChange"
              @current-change="handleRightCurrentChange"
              :current-page="currentPageRight"
              :page-sizes="[10, 20, 30]"
              :page-size="pageSizeRight"
              layout="total, sizes, prev, pager, next, jumper"
              :total="selectedAddProductTableData.length"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button @click="prodHandleClose">关 闭</el-button>
            <el-button type="primary" @click="sureAddProduct()">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  sortList,
  addSort,
  updateSort,
  selectedList,
  selectList,
  saveProductSort,
  deleteSort, relationSelectList
} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'

  export default {
    name: 'goods',
    data: () => {
      var validateNum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入排序号'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      return {
        loading: false, //是显示加载
        addProductDialogVisible: false,//上架弹窗
        sortDialogVisible: false,//下架弹窗
        undercarriageReason: '',//下架原因
        isRewiriteEditor: false,
        dialogTitle: '',
        selectTableData: [],
        productId: '',
        formInline: {
          page: 1,
          rows: 10,
          sort_name: '',
          sort_id: '',
          status: ''
        },
        selectData: {
          page: 1,
          rows: 10,
          id: '',
          content: ''
        },
        selectedData: {
          id: '',
          content: ''
        },
        currentPage: 1, // 当前页码
        pageSize: 10, // 每页的数据条数
        currentPageRight: 1, // 当前页码
        pageSizeRight: 10, // 每页的数据条数
        selectAddProductTableData: [],
        selectedAddProductTableData: [],
        selectAddProductTableDataList: [],
        selectedAddProductTableDataList: [],
        sortRules: {
          status: { required: true, message: '请选择状态', trigger: 'blur' },
          sort_id: [{required: true, validator: validateNum, trigger: 'blur'}],
          sort_name: [{required: true, message: '请输入分类名称', trigger: 'blur'}],
        },
        sortForm: {
          id: '',
          sort_name: '',
          sort_id: '',
          status: '',
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        sale_id: '',
        relation_sale_id: [],
        // rules表单验证
        rules: {},
        dialogImageUrl: '',
        dialogVisible: false,
        imgUrl: '',
        product_id: '',
        product_name: '',
        form: {
          image: ''
        },
        statusList: [{
          name: '有效',
          value: 1
        }, {
          name: '无效',
          value: 0
        }],
        isCanSubmit: true,
        isCanLeftButton: true,
        isCanRightButton: true,
        selectContent:''
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 待选列表查询
      searchSelect() {
        this.selectAddProductTableData = [];
        this.selectData.content = this.selectContent;
        this.currentPage = 1
        this.loading = true
        selectList(this.selectData)
          .then(res => {
            this.loading = false
            if (res.success) {
              this.selectAddProductTableData = res.content;
            }
          })
          .catch(err => {
          })
      },
      addSortdialog() {
        this.sortDialogVisible = true;
        this.dialogTitle = '新增分类';
        this.sortForm = {
          id: '',
          sort_name: '',
          sort_id: '',
          status: '',
        };
      },
      editSortdialog() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.productId = this.selectTableData[0].id;
        this.dialogTitle = '修改分类';
        this.sortDialogVisible = true;
        this.sortForm.sort_name = this.selectTableData[0].sort_name;
        this.sortForm.sort_id = this.selectTableData[0].sort_id;
        this.sortForm.status = this.selectTableData[0].status;
      },
      delSort() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        const title = '是否确认删除分类？';
        this.$confirm(title, '删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          deleteSort(this.selectTableData[0].id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      addProduct(id) {
        this.addProductDialogVisible = true;
        this.selectedData.id = id;
        this.selectData.id = id;
        this.productId = id;
        this.currentPage = 1;
        // this.currentPageRight = 1;
        // this.selectData.content = '';
        // this.selectContent = '';
        selectList(this.selectData)
          .then(res => {
            if (res.success) {
              this.selectAddProductTableData = res.content;
            }
          })
          .catch(err => {
          })
        selectedList(this.selectedData)
          .then(res => {
            if (res.success) {
              this.selectedAddProductTableData = res.content;
            }
          })
          .catch(err => {
          })
      },
      saveSort(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            if (this.dialogTitle == '新增分类') {
              addSort(this.sortForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功增加店铺分类!'
                    });
                    this.sortDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            } else {
              this.sortForm.id = this.productId;
              updateSort(this.sortForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改店铺分类!'
                    });
                    this.sortDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        sortList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      selectDataChange(val) {
        this.selectAddProductTableDataList = val;
        // if (val.length == 0) {
        //   this.isCanRightButton = true
        //   return
        // } else {
        //   this.isCanRightButton = false
        //   return
        // }
      },
      selectedDataChange(val) {
        this.selectedAddProductTableDataList = val
        // if (val.length == 0) {
        //   this.isCanLeftButton = true
        //   return
        // } else {
        //   this.isCanLeftButton = false
        //   return
        // }
      },
      prodHandleClose() {
        this.selectData = {
          page: 1,
          rows: 10,
          id: '',
          content: ''
        }
        this.selectContent = ''
        this.addProductDialogVisible = false
      },
      sureAddProduct() {
        let addProducts = [];
        this.selectedAddProductTableData.forEach((item) => {
          addProducts.push(item.sale_id)
        })
        let parameter = {
          id: this.productId,
          addProducts: addProducts
        }
        saveProductSort(parameter)
          .then(res => {
            this.isCanSubmit = true;
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '您已成功为店铺分类添加商品!'
              });
              this.getdata(this.formInline)
              this.prodHandleClose()
            }
          })
          .catch(err => {
            this.isCanSubmit = true;
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      gotoLeft() {
        if (this.selectedAddProductTableDataList.length) {
          let idListA = this.selectAddProductTableData.map(i => i.sale_id)
          let target = this.selectAddProductTableData
          let tempB = this.selectedAddProductTableDataList.filter(val=>!idListA.includes(val.sale_id))
          target = target.concat(tempB)
          this.selectAddProductTableData = target;
          let sendTable = this.selectedAddProductTableData;
          this.$refs.multipleselectedTable.selection.forEach((Ele, index) => {
            for (let i = 0; i < sendTable.length; i++) {
              let sale_id = sendTable[i].sale_id;
              if (sale_id == Ele.sale_id) {
                sendTable.splice(i, 1);
              }
            }
          });
          let totalPage = Math.ceil((this.selectedAddProductTableData.length) / this.pageSizeRight)
          this.currentPageRight = totalPage < this.currentPageRight ? totalPage : this.currentPageRight
          this.currentPageRight = this.currentPageRight < 1 ? 1 : this.currentPageRight
        } else {
          this.$message.error('请至少选择一条数据再操作!');
          return
        }
      },
      gotoRight() {
        if (this.selectAddProductTableDataList.length) {
          let idListA = this.selectedAddProductTableData.map(i => i.sale_id)
          let target = this.selectedAddProductTableData
          let tempB = this.selectAddProductTableDataList.filter(val=>!idListA.includes(val.sale_id))
          target = target.concat(tempB)
          this.selectedAddProductTableData = target;
          let sendTable = this.selectAddProductTableData;
          this.$refs.multipleselectTable.selection.forEach((Ele, index) => {
            for (let i = 0; i < sendTable.length; i++) {
              let sale_id = sendTable[i].sale_id;
              if (sale_id == Ele.sale_id) {
                sendTable.splice(i, 1);
              }
            }
          });
          let totalPage = Math.ceil((this.selectAddProductTableData.length) / this.pageSize)
          this.currentPage = totalPage < this.currentPage ? totalPage : this.currentPage
          this.currentPage = this.currentPage < 1 ? 1 : this.currentPage
        } else {
          this.$message.error('请至少选择一条数据再操作!');
          return
        }
      },
      //每页条数改变时触发 选择一页显示多少行
      handleLeftSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 1;
        this.pageSize = val;
      },
      //当前页改变时触发 跳转其他页
      handleLeftCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
      },
      handleRightSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPageRight = 1;
        this.pageSizeRight = val;
      },
      //当前页改变时触发 跳转其他页
      handleRightCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPageRight = val;
      },
      handleClose() {
        this.$refs["sortForm"].resetFields();
        this.sortDialogVisible = false;
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.sort_name == cell.innerText || row.sort_id == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .sortForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .sortForm .el-input--small {
    width: 320px;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }
</style>





// WEBPACK FOOTER //
// src/views/store/storeSort.vue